import { Box, Stack, Typography } from "@mui/material";
import { Control, Controller, FieldErrors } from "react-hook-form";
import CheckboxList, {
  CheckboxItem,
} from "@/components/common/list/checkboxList";
import { TimeOfDay } from "@/types";
import { handleToggleTimeOfDay, timeOfDayFormOptions } from "../constants";

export type TimeOfDaySelectorFormValues = {
  selectedTimeOfDay: TimeOfDay[];
};

type TimeOfDaySelectorProps = {
  control: Control<TimeOfDaySelectorFormValues>;
  errors: FieldErrors<TimeOfDaySelectorFormValues>;
};

const createTimeOfDayCheckboxItems = (
  fieldValue: TimeOfDay[],
  onFieldChange: (value: TimeOfDay[]) => void
): CheckboxItem<TimeOfDay>[] =>
  timeOfDayFormOptions.map((timeOption) => ({
    id: timeOption.id,
    label: (
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        justifyContent="space-between"
      >
        {timeOption.label}
        {timeOption.icon}
      </Stack>
    ),
    onChange: (timeOfDay: TimeOfDay) => {
      const newTimeOfDay = handleToggleTimeOfDay(timeOfDay, fieldValue);
      onFieldChange(newTimeOfDay);
    },
    isChecked: fieldValue.includes(timeOption.id),
  }));

export default function TimeOfDaySelector({
  control,
  errors,
}: TimeOfDaySelectorProps) {
  return (
    <Controller
      name="selectedTimeOfDay"
      control={control}
      render={({ field }) => {
        const checkboxItems = createTimeOfDayCheckboxItems(
          field.value as TimeOfDay[],
          (value: TimeOfDay[]) => field.onChange(value)
        );

        return (
          <Box>
            <CheckboxList items={checkboxItems} />
            {errors.selectedTimeOfDay && (
              <Typography
                variant="labelSmall"
                color="error.main"
                sx={{
                  mt: 1.5,
                  textAlign: "left",
                }}
              >
                {errors.selectedTimeOfDay?.message as string}
              </Typography>
            )}
          </Box>
        );
      }}
    />
  );
}
